import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import {
  FormTemplateKeysListResponse,
  GetFormTemplateKeysQueryDto,
  IFormTemplateKey,
} from './types';

const EMPTY_KEYS: IFormTemplateKey[] = [];

/**
 * Hook to fetch all form template keys with optional filters + search
 */
export const useFormTemplateKeys = (params?: GetFormTemplateKeysQueryDto) => {
  const query = new URLSearchParams();

  if (params?.liveFormId) {
    query.append('liveFormId', params.liveFormId);
  }

  if (params?.hasLiveForm !== undefined) {
    query.append('hasLiveForm', String(params.hasLiveForm));
  }

  if (params?.key && params.key.length > 0) {
    params.key.forEach((k) => query.append('key', k));
  }

  if (params?.searchTerm) {
    query.append('searchTerm', params.searchTerm);
  }

  if (params?.offset !== undefined) {
    query.append('offset', params.offset.toString());
  }

  if (params?.limit !== undefined) {
    query.append('limit', params.limit.toString());
  }

  const queryString = query.toString();
  const url = queryString ? `${BASE_URL}?${queryString}` : BASE_URL;

  const { data, error, isLoading, mutate } =
    useSWR<FormTemplateKeysListResponse>(
      url,
      SWRFetcher({
        method: 'GET',
      })
    );

  const pageSize = params?.limit ?? 10;
  const totalCount = data?.count ?? 0;

  return {
    data,
    error,
    isLoading,
    mutate,
    keys: data?.formTemplateKeys ?? EMPTY_KEYS,
    count: totalCount,
    totalPages: Math.ceil(totalCount / pageSize),
    totalItems: totalCount,
  };
};
